import React from "react";
import ResumeApi from "../../../Data/HomePage/ResumeApi";

function ResumeAreaSection() {
  return (
    <>
      <section className="resume-area page-section scroll-to-page" id="resume">
        <div className="custom-container">
          <div className="resume-content content-width">
            <div className="section-header">
              <h4
                className="subtitle scroll-animation"
                data-animation="fade_from_bottom"
              >
                <i className="las la-briefcase"></i> {ResumeApi.data.title}
              </h4>
              <h1
                className="scroll-animation"
                data-animation="fade_from_bottom"
              >
                Education & <span>Experience</span>
              </h1>
            </div>

            <div className="resume-timeline">
              {ResumeApi.data.list.map((value, index) => {
                return (
                  <div
                    className="item scroll-animation"
                    data-animation="fade_from_right"
                  >
                    <span className="date">
                      {value.degree} ({value.year})
                    </span>
                    <h2>{value.title}</h2>
                    <span className="mb-0 px-1 py-1 border rounded border-light border-opacity-25">
                      {value.field_of_study_and_company_name}
                    </span>
                    <pre className="mb-0 mt-2">{value.desc}</pre>
                    {/* {JSON.stringify(value.skill.model.map((skill, index) =>({skill})))} */}
                    {/* {value.skill.model.map((skill, index) => {
                      return (
                        <button
                          type="button"
                          className="btn btn-secondary btn-outline-dark btn-sm"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Tooltip on top"
                        >
                          {skill}
                        </button>
                      );
                    })} */}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ResumeAreaSection;
